import * as React from 'react';

import {ListView} from 'shells/list-view/list-view';

import type {DripSequenceStubFragment as DripSequence} from 'nutshell-graphql-types';

import {DripSequenceListItemWrapper} from './drip-sequence-list-item-wrapper';
import {EmptyState} from './empty-state';

import styles from './drip-sequences-list-page.module.css';

type Props = {
    isLoading: boolean;
    isFiltering: boolean;
    isShowingArchived: boolean;
    error: string | null | undefined;
    dripSequences: DripSequence[];
    onDeleteDripSequence: (dripSequenceId: string) => Promise<any>;
    onDuplicateDripSequence?: (dripSequenceId: string) => any;
    onRestoreDripSequence: (dripSequenceId: string) => Promise<any>;
    handleCreateNewDripSequence: () => any;
};

export function DripSequencesBoardView(props: Props) {
    const {
        isLoading,
        isFiltering,
        isShowingArchived,
        error,
        dripSequences,
        onDeleteDripSequence,
        onRestoreDripSequence,
        handleCreateNewDripSequence,
    } = props;

    return (
        <div className={styles['drip-sequences-list-container']}>
            <ListView
                collection={dripSequences}
                itemSpacing={16}
                renderRow={(dripSequence) => {
                    return (
                        <div
                            key={dripSequence.id}
                            className={styles['drip-sequence-list-item-container']}
                        >
                            <DripSequenceListItemWrapper
                                dripSequence={dripSequence}
                                isArchived={isShowingArchived}
                                onDeleteDripSequence={() => {
                                    return onDeleteDripSequence(dripSequence.id);
                                }}
                                onRestoreDripSequence={() => {
                                    return onRestoreDripSequence(dripSequence.id);
                                }}
                                onDuplicateDripSequence={props.onDuplicateDripSequence}
                                // @ts-expect-error
                                isLoading={isLoading}
                            />
                        </div>
                    );
                }}
                isLoading={isLoading}
                loadingState={{itemHeight: 152, listPadding: 0, backgroundColor: 'white'}}
                isError={Boolean(error)}
                errorState={{errorMessage: error}}
                isFiltering={isFiltering || isShowingArchived}
                nothingFoundState={{
                    title: 'No drip sequences were found',
                }}
                emptyStateComponent={<EmptyState onPrimaryCtaClick={handleCreateNewDripSequence} />}
            />
        </div>
    );
}
